import { render, staticRenderFns } from "./QuestionsSlide.vue?vue&type=template&id=7685ee26"
import script from "./QuestionsSlide.vue?vue&type=script&lang=js"
export * from "./QuestionsSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7685ee26')) {
      api.createRecord('7685ee26', component.options)
    } else {
      api.reload('7685ee26', component.options)
    }
    module.hot.accept("./QuestionsSlide.vue?vue&type=template&id=7685ee26", function () {
      api.rerender('7685ee26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/slides/QuestionsSlide.vue"
export default component.exports